var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAndroidIcon = function SvgAndroidIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15V17.5C9.16667 17.9583 8.79167 18.3333 8.33333 18.3333C7.875 18.3333 7.5 17.9583 7.5 17.5V15H9.16667Z",
    fill: "#12B985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15V17.5C12.5 17.9583 12.125 18.3333 11.6667 18.3333C11.2084 18.3333 10.8334 17.9583 10.8334 17.5V15H12.5Z",
    fill: "#12B985"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.16667V13.3333C14.1667 14.25 13.4167 15 12.5 15H7.50004C6.58337 15 5.83337 14.25 5.83337 13.3333V9.16667C5.83337 8.25 6.58337 7.5 7.50004 7.5H12.5C13.4167 7.5 14.1667 8.25 14.1667 9.16667Z",
    fill: "#12B985"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 9.16671V12.5C4.16667 12.9584 3.79167 13.3334 3.33333 13.3334C2.875 13.3334 2.5 12.9584 2.5 12.5V9.16671C2.5 8.70837 2.875 8.33337 3.33333 8.33337C3.79167 8.33337 4.16667 8.70837 4.16667 9.16671Z",
    fill: "#12B985"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.16671V12.5C17.5 12.9584 17.125 13.3334 16.6667 13.3334C16.2084 13.3334 15.8334 12.9584 15.8334 12.5V9.16671C15.8334 8.70837 16.2084 8.33337 16.6667 8.33337C17.125 8.33337 17.5 8.70837 17.5 9.16671Z",
    fill: "#12B985"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 6.3333H12C12.7333 6.3333 13.3333 5.73329 13.3333 4.99996C13.3333 3.15829 11.8416 1.66663 9.99996 1.66663C8.15829 1.66663 6.66663 3.15829 6.66663 4.99996C6.66663 5.73329 7.26661 6.3333 7.99994 6.3333Z",
    fill: "#12B985"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroidIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android-icon.66aa180b.svg";
export { ForwardRef as ReactComponent };